/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteVerificationMemo$Params {
  id: number;
  memoId: number;
  'X-API-Version'?: string;
}

export function deleteVerificationMemo(http: HttpClient, rootUrl: string, params: DeleteVerificationMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteVerificationMemo.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('memoId', params.memoId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteVerificationMemo.PATH = '/api/user-verifications/{id}/memos/{memoId}';
